<template>
  <div class="login-container">
    <h3 class="login-form-title center"></h3>
    <form class="login-form clearfix">
      <div class="clearfix marginB10 login-item-wrap">
        <label
          class="login-icon-label el-icon-phone-outline w30 h34 fl"
          style="line-height: 34px; text-align: center"
        ></label>
        <input
          type="text"
          v-model="docMobile"
          class="login-input h34 w220 fl"
          placeholder="请输入手机号"
          @input="changephone"
          required
        />
      </div>
      <div class="clearfix marginB10 login-item-wrap">
        <label
          class="login-icon-label el-icon-edit w30 h34 fl"
          style="line-height: 34px; text-align: center"
        ></label>
        <input
          type="password"
          v-model="docPassword"
          class="login-input h34 w220 fl"
          placeholder="请输入密码"
          required
        />
      </div>
      <div class="clearfix marginB10 login-item-wrap" v-show="displayCode">
        <label class="login-icon-label login-icon-pwd w30 h34 fl"></label>
        <input
          type="text"
          v-model="captcha"
          class="login-input h34 w120 fl"
          placeholder="请输入验证码"
          required
        />
        <v-send-code
          v-model="docMobile"
          :docMobile="docMobile"
          :docPassword="docPassword"
          style="
            display: inline-block;
            width: 100px;
            line-height: 34px;
            text-align: center;
            font-size: 12px;
            cursor: pointer;
          "
          class="fl h34 color_main"
          @ok="ok"
        ></v-send-code>
      </div>
      <div class="clearfix marginB25"></div>
      <el-button type="primary" class="login-btn" @click="login" :loading="isSuccess"
        >立即登录</el-button
      >
    </form>
    <div class="login-show" v-show="seen">
      <p>
        温馨提示：您目前使用的浏览器类型有可能存在部分兼容性问题，导致部分功能无法正常使用，推荐使用谷歌浏览器。
      </p>
      <a
        class="login-load"
        href="https://www.baidu.com/link?url=mox1b_ORCrh7rOXoeUteev1em9j9Qtm7HNikc8EJ6vjhGwQ28bWrCQ3f64jQ-gcyBkS9AiMv7OExfBpFKDgRFy79ffXO6Pzx6Mxnx6gJt37&wd=&eqid=c15f93b8000169510000000459756b6a"
        target="_blank"
        >点击下载</a
      >
    </div>
  </div>
</template>
<style></style>
<script>
// import { dynamicRoutes } from "../../route";
import axiosUtil from "../utils/AxiosUtils.js";
import VSendCode from "../components/common/v-send-codecopy";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      docMobile: "", //用户身份证
      docPassword: "", //用户密码
      captcha: "", //验证码
      cid: "",
      isSuccess: false,
      seen: false,
      userSig: "",
      timercompare: null,
      displayCode: true,
      // displayCode: false,
    };
  },
  beforeCreate() {
    console.log('beforeCreate=============>loading')
    //清空缓存,fleet 2023.07.26
    let userInfoStr = localStorage.getItem("loginInformation")
    //退出的时候清空缓存,fleet 2023年7月18日
    localStorage.clear()
    sessionStorage.clear()
    if (userInfoStr) {
      localStorage.setItem("loginInformation", userInfoStr)
    }
  },
  mounted() {
    console.log('mounted=============>loading')
    document.addEventListener("keyup", this.enterKeyUpHandler, false);
    this.myBrowser();
  },
  beforeDestroy() {
    //组件销毁前解除事件绑定
    let _this = this;
    document.removeEventListener("keyup", _this.enterKeyUpHandler, false);
  },
  components: {VSendCode},
  methods: {
    // loginTrtc() {
    //   let that = this;
    //   let options = {
    //     service: "smarthos.tencent.imo.generate.user.sig",
    //     hosId: "1100000001",
    //     userType: "DOC",
    //     userId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
    //     token: localStorage.getItem("token"),
    //   };
    //   axiosUtil(options, function (data) {
    //     if (data.code == "0") {
    //       let userSig = data.obj.userSig;
    //       let promise = that.tim.login({
    //         userID: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
    //         userSig: userSig,
    //       });
    //       promise
    //         .then(function (imResponse) {
    //           let IM_userInfo = {
    //             userID: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
    //             userSig: userSig,
    //           };
    //           localStorage.setItem("IM_userInfo", JSON.stringify(IM_userInfo));
    //           // let userID = JSON.parse(sessionStorage.getItem("loginInfo")).doc.id;
    //           // that.trtcCalling.login({ userID, userSig });
    //           // Vue.prototype.tim = tim1;
    //         })
    //         .catch(function (imError) {
    //           console.warn("login error:", imError); // 登录失败的相关信息
    //         });
    //     }
    //   });
    // },
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    //获取当前日期
    getTimer() {
      const nowDate = new Date();
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      };
      const newmonth = date.month > 10 ? date.month : "0" + date.month;
      const day = date.date > 10 ? date.date : "0" + date.date;
      let systemDate = date.year + "-" + newmonth + "-" + day;
      return systemDate;
    },
    //比较存储时间是否七天之内
    tab(date1, date2) {
      let _this = this;
      var oDate1 = new Date(date1);
      var oDate2 = new Date(date2);
      if (oDate1.getTime() > oDate2.getTime()) {
        _this.timercompare = false;
      } else {
        _this.timercompare = true;
      }
    },
    //输入手机号显示隐藏发送验证码输入框
    changephone() {
      console.log(`========changephone=====>`,)
      let _this = this;
      if (_this.docMobile.length == 11) {
        let loginInformation = JSON.parse(localStorage.getItem("loginInformation"));
        console.log(`=====loginInformationloginInformation========>`, loginInformation)
        if (loginInformation) {
          if (Base64.decode(loginInformation.docMobile) == _this.docMobile) {
            let StorageTime = Base64.decode(loginInformation.date);
            _this.tab(StorageTime, _this.getDay(7));
            if (_this.timercompare == true) {
              _this.displayCode = false;
            } else if (_this.timercompare == false) {
              _this.displayCode = true;
            }
          } else {
            _this.displayCode = true;
          }
        } else {
          _this.displayCode = true;
        }
      }
    },
    ok({cid, value}) {
      this.cid = cid;
      process.env.NODE_ENV === "development" && value && (this.captcha = value);
    },
    myBrowser() {
      let explorer = navigator.userAgent;
      //ie
      if (explorer.indexOf("MSIE") >= 0) {
        this.seen = true;
      }
      //firefox
      else if (explorer.indexOf("Firefox") >= 0) {
        this.seen = true;
      }
      //Chrome
      else if (explorer.indexOf("Chrome") >= 0) {
        this.seen = false;
      }
      //Opera
      else if (explorer.indexOf("Opera") >= 0) {
        this.seen = true;
      }
      //Safari
      else if (explorer.indexOf("Safari") >= 0) {
        this.seen = true;
      }
      //Netscape
      else if (explorer.indexOf("Netscape") >= 0) {
        this.seen = true;
      }
    },
    enterKeyUpHandler(ev) {
      // 回车事件
      let e = ev || event;
      if (e.keyCode === 13 || e.which == 13) {
        this.login(); //调用登录函数
      }
    },
    login() {
      //点击按钮登录
      this.isSuccess = true; //登录按钮变为加载状态
      const _this = this;
      /*加密*/
      // let shaObj = new jsSHA("SHA-512", "TEXT");
      let newPwd = _this.docPassword.toLowerCase(); // 密码不区分大小写
      let docNewPassword = sha512(hex_md5(newPwd) + newPwd);
      let options;
      if (_this.displayCode == false) {
        options = {
          hosId: "1100000001",
          docMobile: _this.docMobile,
          docPassword: docNewPassword,
          deviceType: "WEB",
          isCheckVerificationCode: 1,
          deviceId: window.socket != undefined ? window.socket.id : "12345678",
          service: "smarthos.user.doc.login.web", //smarthos.user.doc.login.web|smarthos.user.doc.login
        };
      } else if (_this.displayCode == true) {
        options = {
          hosId: "1100000001",
          docMobile: _this.docMobile,
          isCheckVerificationCode: 0,
          docPassword: docNewPassword,
          cid: _this.cid,
          captcha: _this.captcha,
          deviceType: "WEB",
          deviceId: window.socket != undefined ? window.socket.id : "12345678",
          service: "smarthos.user.doc.login.web", //smarthos.user.doc.login.web|smarthos.user.doc.login
        };
      }
      axiosUtil(
          options,
          function (data) {
            console.log(`=====axiosUtil======login==>`, data)
            _this.isSuccess = false;
            _this.$store.dispatch("getUserInfo", data.obj); //获取登录用户信息储存到store
            //_this.$store.dispatch("", res.dta.obj.docId);//获取当前登录id储存到store
            window.localStorage.setItem("token", data.token); //储存token
            let userInfo, identity;
            try {
              userInfo = JSON.stringify(data.obj);
              identity = data.obj;
            } catch (e) {
              userInfo = "";
            }
            // window.localStorage.setItem("userInfo", userInfo);
            window.localStorage.setItem(
                "docIdcardA",
                JSON.stringify({
                  url: data.obj.docIdcardUrlA,
                  attId: data.obj.docIdcardUrlAAttaId,
                })
            ); //储存用户信息
            window.localStorage.setItem(
                "docIdcardB",
                JSON.stringify({
                  url: data.obj.docIdcardUrlB,
                  attId: data.obj.docIdcardUrlBAttaId,
                })
            ); //储存用户信息
            window.localStorage.setItem(
                "loginInformation",
                JSON.stringify({
                  docMobile: Base64.encode(_this.docMobile),
                  date: Base64.encode(_this.getTimer()),
                })
            );

            //fleet
            //2023年7月6日
            window.sessionStorage.setItem("isShowTodayDept", data.obj.isShowTodayDept)
            window.sessionStorage.setItem("loginInfo", JSON.stringify(data.obj))

            _this.getAppId(data, identity)

            //储存用户登录信息
            // let encode = Base64.encode(_this.docMobile);
            // let decode = Base64.decode(encode);

            // _this.$router.addRoutes(dynamicRoutes);
            /*window.localStorage.setItem("docId", data.obj.docId);//储存用户Id*/

            // _this.loginTrtc();
          },
          function () {
            _this.isSuccess = false;
          }
      );
    },

    //获取appid 2023年10月11日
    getAppId(data, identity) {
      //
      let _this = this

      console.log(`===data.obj.doc.hosId==========>`, data.obj.doc)
      let options = {
        hosId: data.obj.doc.hosId,
        service: "smarthos.tencent.imo.config.by.hosid",
      };

      axiosUtil(
          options, function (data) {
            console.log(`=====axiosUtil======getAppId==>`, data)
            if (data.code === '0') {
              let videoAppId = data.obj.videoAppId
              window.sessionStorage.setItem("videoAppId", videoAppId)
              //fleet 2023.11.15  混流接口是否调用新的 1表示是 0表示不是
              window.sessionStorage.setItem("isRequestNewMixInterface", data.obj.isRequestNewMixInterface)

              if (identity.doc.docTitle == "药师") {
                _this.$router.push("/main/prescription-check");
              } else if (identity.doc.hosId == "1100000060") {
                _this.$router.push("/main/questionnaireList");
              } else {
                _this.$router.push("/main");
              }
            } else {
              alert("获取appid失败")
            }
          })
    }
  },
};
</script>
